import { createSlice } from '@reduxjs/toolkit';

type InitialState = {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  username: string;
  gender: string;
  age_group: string;
  country: string;
  nearest_city: string;
  nearest_airport: string;
  chosen_plan: number;
  primary_travel_purposes: string[];
  destination_types: string[];
  activity_interests: string[];
  travel_preference: string;
  budget_preference: string;
  pace_preference: string;
  is_inviting_others: boolean;
  unit_system: string;
  trip_planning_style: string;
};

const initialState: InitialState = {
  id: 0,
  first_name: '',
  last_name: '',
  email: '',
  username: '',
  gender: '',
  age_group: '',
  country: '',
  nearest_city: '',
  nearest_airport: '',
  chosen_plan: 0,
  primary_travel_purposes: [],
  destination_types: [],
  activity_interests: [],
  travel_preference: '',
  budget_preference: '',
  pace_preference: '',
  is_inviting_others: false,
  unit_system: '',
  trip_planning_style: '',
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserInfo: (state, { payload }) => {
      const {
        id,
        first_name,
        last_name,
        email,
        username,
        gender,
        age_group,
        country,
        nearest_city,
        nearest_airport,
        chosen_plan,
        primary_travel_purposes,
        destination_types,
        activity_interests,
        travel_preference,
        budget_preference,
        pace_preference,
        is_inviting_others,
        unit_system,
        trip_planning_style,
      } = payload;

      state.id = id ?? state.id;
      state.first_name = first_name ?? state.first_name;
      state.last_name = last_name ?? state.last_name;
      state.email = email ?? state.email;
      state.username = username ?? state.username;
      state.gender = gender ?? state.gender;
      state.age_group = age_group ?? state.age_group;
      state.country = country ?? state.country;
      state.nearest_city = nearest_city ?? state.nearest_city;
      state.nearest_airport = nearest_airport ?? state.nearest_city;
      state.chosen_plan = chosen_plan ?? state.chosen_plan;
      state.primary_travel_purposes = primary_travel_purposes ?? state.primary_travel_purposes;
      state.destination_types = destination_types ?? state.destination_types;
      state.activity_interests = activity_interests ?? state.activity_interests;
      state.travel_preference = travel_preference ?? state.travel_preference;
      state.budget_preference = budget_preference ?? state.budget_preference;
      state.pace_preference = pace_preference ?? state.pace_preference;
      state.is_inviting_others = is_inviting_others ?? state.is_inviting_others;
      state.unit_system = unit_system ?? state.unit_system;
      state.trip_planning_style = trip_planning_style ?? state.trip_planning_style;
    },
    logOutUser: (state) => {
      state.id = 0;
      state.first_name = '';
      state.last_name = '';
      state.email = '';
      state.username = '';
      state.gender = '';
      state.age_group = '';
      state.country = '';
      state.nearest_city = '';
      state.nearest_airport = '';
      state.chosen_plan = 0;
      state.primary_travel_purposes = [''];
      state.destination_types = [''];
      state.activity_interests = [''];
      state.travel_preference = '';
      state.budget_preference = '';
      state.pace_preference = '';
      state.is_inviting_others = false;
      state.unit_system = '';
      state.trip_planning_style = '';
    }
  },
});

export const { setUserInfo, logOutUser } = userSlice.actions;

export default userSlice.reducer;
